<template>
  <div>
    <div class="header p-4 d-flex justify-content-between">
      <h3 class="m-0 p-0">{{ title }}</h3>
      <div class="clickable" @click="$emit('close')">
        <iconClose class="icon icon-close"></iconClose>
      </div>
    </div>
    <div class="slider">
      <div class="position-relative image-slider__slider">
        <template v-if="images.length && images.length > 1">
          <ci-slider
            :options="sliderConfig"
            @moved="onSliderMoved"
            @init="onSliderInit"
          >
            <div class="glide__track h-100" data-glide-el="track">
              <ul class="glide__slides h-100 m-0 p-0">
                <li
                  v-for="(image, idx) in images"
                  :key="idx"
                  class="glide__slide position-relative h-100"
                >
                  <img
                    :key="idx"
                    :src="image.variants['4_3_big'].url"
                    class="img-fluid"
                    :draggable="false"
                  />
                </li>
              </ul>
            </div>
          </ci-slider>

          <div class="glide__arrows" data-glide-el="controls">
            <div
              v-if="images.length > 1"
              data-glide-dir="<"
              class="
                image-slider__image-navigation image-slider__image-navigation--prev
                d-flex
                align-items-center
                position-absolute
                h-100
                px-2
              "
              @click.prevent.stop="onPreviousImage"
            >
              <iconArrowWhite class="icon icon--arrow"></iconArrowWhite>
            </div>
            <div
              v-if="images.length > 1"
              data-glide-dir=">"
              class="
                image-slider__image-navigation image-slider__image-navigation--next
                d-flex
                align-items-center
                position-absolute
                h-100
                px-2
              "
              @click.prevent.stop="onNextImage"
            >
              <iconArrowWhite class="icon icon--arrow"></iconArrowWhite>
            </div>
          </div>
          <div
            v-if="images.length > 1"
            class="image-slider__image-gradient position-absolute"
          >
            <div
              class="
                image-slider__image-pagination
                d-flex
                justify-content-center
                align-items-center
                position-absolute
              "
            >
              <span
                v-for="(img, idx) in images"
                :key="idx"
                class="image-slider__image-pagination-dot"
                :class="{
                  'image-slider__image-pagination-dot--active':
                    activeImage - 1 === idx,
                }"
                >{{ idx + 1 }}</span
              >
            </div>
          </div>
        </template>

        <!-- only one image -->
        <img
          v-if="images.length === 1"
          :src="images[0].variants['4_3_big'].url"
          class="image-slider__image-single"
        />
      </div>
    </div>
    <div class="p-4">
      <p
        v-if="images[activeImage - 1] && images[activeImage - 1].title"
        class="m-0 p-0"
      >
        {{ images[activeImage - 1].title }}
      </p>
    </div>
  </div>
</template>

<script>
import { CiSlider } from '@/components'

import iconArrowWhite from '@/assets/icons/arrow-white-dynamic.svg'
import iconClose from '@/assets/icons/close-dark.svg'

export default {
  name: 'CiImageModal',

  components: {
    CiSlider,
    iconArrowWhite,
    iconClose,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    images: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeImage: 1,
      slider: null,
      sliderConfig: {
        gap: 0,
        perView: 1,
        startAt: 0,
        type: 'carousel',
      },
    }
  },

  methods: {
    onSliderInit(slider) {
      this.slider = slider
    },

    onSliderMoved(slider) {
      this.activeImage = slider.index + 1
    },

    onPreviousImage() {
      this.slider.go('<')
    },

    onNextImage() {
      this.slider.go('>')
    },
  },
}
</script>
